export enum ERouteName {
  ROOT = "ROOT",
  AUTHENTICATION = "AUTHENTICATION",
  AUTHENTICATION__LOGIN = "AUTHENTICATION__LOGIN",
  AUTHENTICATION__LOGOUT = "AUTHENTICATION__LOGOUT",
  SEARCH_SITE = "SEARCH_SITE",
  DEVICES_MODULATOR_DETAILS = "DEVICES_MODULATOR_DETAILS",
  DEVICES_PILOTS_DETAILS = "DEVICES_PILOTS_DETAILS",
  DEVICES_THIRD_PARTY_SENSORS_DETAILS = "DEVICES_THIRD_PARTY_SENSORS_DETAILS",
  SITES_ROOT = "SITES_ROOT",
  SITES_OVERVIEW = "SITES_OVERVIEW",
  SITES_QUALITY_CONTROL = "SITES_QUALITY_CONTROL",
  SITES_DEVICES = "SITES_DEVICES",
  SITES_GALLERY = "SITES_GALLERY",
  SITES_WORKING_CONDITION = "SITES_WORKING_CONDITION",
  SITES_WORKING_CONDITION__ACQUISITION = "SITES_WORKING_CONDITION__ACQUISITION",
  SITES_WORKING_CONDITION__MODULATION = "SITES_WORKING_CONDITION__MODULATION",
}
